import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { TrailBalancePDFAPi, TrailBalanceSearchApi } from "./TrailAction"
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { setHeading } from "../../../accounts/account.actions";
import { startFinancialDate, endFinancialDate } from "../../../../../global/globalFunctions";
// import _ from "lodash";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const ViewTrail = (props) => {
    const [startDate, setStartDate] = useState(startFinancialDate);
    const [endDate, setEndDate] = useState(endFinancialDate);

    function SearchLedger() {
        props.TrailBalanceSearchApi({
            startDate: startDate,
            endDate: endDate,
        },
            startDate,
            endDate,
        );
    }

    const ExportPDF = () => {
        props.TrailBalancePDFAPi({
            startDate: startDate,
            endDate: endDate,
        },
            startDate,
            endDate,
        );
    }

    useEffect(() => {
        props.setHeading("Trail Balance");
    }, []);

    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label><b>Start Date *</b></Form.Label>
                            <Form.Control
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            >
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Label><b>End Date *</b></Form.Label>
                            <Form.Control
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            >
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>

                <div className="sendDiv" style={{ marginTop: "35px" }}>
                    <Link to="/accountsModule/TrailBalance/TrailSearch">
                        <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SearchLedger}><b>TRAIL BALANCE VIEW</b></Button>
                    </Link>
                </div>

                <div className="sendDiv" style={{ marginTop: "0px" }}>
                    <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => ExportPDF()}><b>TRAIL BALANCE PDF</b></Button>
                </div>

            </Container>
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        TrailBalancePDFAPi: (startDate, endDate) => dispatch(TrailBalancePDFAPi(startDate, endDate)),
        TrailBalanceSearchApi: (data, startDate, endDate, accountName) => dispatch(TrailBalanceSearchApi(data, startDate, endDate, accountName)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ViewTrail);